import { Box, Container } from "@sembark-travel/ui-base"
import {
	Breadcrumbs,
	searchToQuery,
	useGetBackUrlFromLocation,
} from "@sembark-travel/ui-router"
import { Helmet } from "react-helmet-async"
import { NewItemForm } from "../../../Supplier"
import { generatePath, useLocation, useNavigate } from "../../../router-utils"
import {
	ForbidUnlessAuthorized,
	PERMISSIONS,
	useCheckPermissions,
} from "../../../Auth"

export default function NewSupplier() {
	const { hasPermission } = useCheckPermissions()
	const navigate = useNavigate()
	const location = useLocation()
	const { type } = searchToQuery<{ type: string }>(location?.search)
	function navigateBackToList() {
		if (hasPermission(PERMISSIONS.VIEW_HOTEL_SUPPLIERS)) {
			return navigate("/suppliers/hotel")
		} else {
			return navigate("/suppliers/transport")
		}
	}
	const back = useGetBackUrlFromLocation()
	const route = hasPermission(PERMISSIONS.VIEW_HOTEL_SUPPLIERS)
		? generatePath("/suppliers/hotel")
		: generatePath("/suppliers/transport")
	return (
		<ForbidUnlessAuthorized
			anyPermissions={[
				PERMISSIONS.VIEW_TRANSPORT_SERVICE_PROVIDERS,
				PERMISSIONS.VIEW_HOTEL_SUPPLIERS,
			]}
		>
			<Helmet>
				<title>New Suppliers</title>
			</Helmet>
			<Breadcrumbs
				title="New Supplier"
				items={[
					[back ?? route, "Suppliers"],
					["", "New"],
				]}
			/>
			<Box paddingX={{ md: "4" }} paddingY={{ md: "8" }}>
				<Box maxWidth="6xl" marginX="auto">
					<Box borderWidth={{ md: "1" }} rounded="md" bgColor="default">
						<Container paddingY="6">
							<NewItemForm
								initialValues={{
									supplies_cabs: type === "cabs" ? 1 : 0,
									supplies_travel_activities:
										type === "travel_activities" ? 1 : 0,
									supplies_hotels: type === "hotels" ? 1 : 0,
								}}
								keepInitialSuppliesSelected
								onSuccess={(data) =>
									navigate("/suppliers/:supplierId", {
										params: {
											supplierId: data.id.toString(),
										},
										replace: true,
									})
								}
								onCancel={navigateBackToList}
							/>
						</Container>
					</Box>
				</Box>
			</Box>
		</ForbidUnlessAuthorized>
	)
}
